import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dealId: '',
  },
  getters: {
  },
  mutations: { 
    updateStore(state, data) {
      state[data.var] = data.val
    }
  },
  actions: {
  },
  modules: {
  }
})
